/**
 * 微信定位
 */

import wx from 'weixin-jsapi'
import storage from '@/utils/storage'
import api from '@/utils/api'

export default {
    methods: {
        getLocation() {
            return new Promise((resolve, reject) => {
                if (storage.get('address')) {
                    resolve(JSON.parse(storage.get('address')))
                } else {
                    const params = {
                        url: window.location.href
                    }
                    api.getWxSdkInfo(params).then((res) => {
                        console.log('getLocation文件', res)
                        if (res.data) {
                            // wx.config({
                            //     appId: res.data.app_id,
                            //     timestamp: res.data.timestamp,
                            //     nonceStr: res.data.noncestr,
                            //     signature: res.data.signature,
                            //     jsApiList: ['getLocation']
                            // })
                            // wx.ready(function() {
                            wx.getLocation({
                                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                                success: function(res) {
                                    if (res.longitude && res.latitude) {
                                        // 更新坐标
                                        api.getFarmerLocation({ longitude: res.longitude + '', latitude: res.latitude + '' })
                                        storage.set('curLng', res.longitude)
                                        storage.set('curLat', res.latitude)
                                        AMap.plugin('AMap.Geocoder', function() {
                                            var geocoder = new AMap.Geocoder({
                                                city: '010'
                                            })
                                            geocoder.getAddress([res.longitude, res.latitude], function(status, result) {
                                                result.regeocode.curLng = res.longitude
                                                result.regeocode.curLat = res.latitude
                                                storage.set('address', JSON.stringify(result.regeocode))
                                                // regeocode.addressComponent.province // 省
                                                // regeocode.addressComponent.city // 市
                                                // regeocode.addressComponent.district // 区
                                                resolve(result.regeocode)
                                            })
                                        })
                                    }
                                }
                            })
                            // })
                        }
                    }).catch((err) => {
                        reject(err)
                    })
                }
            })
        }
    }
}
